import { useViewContext } from "@editor-providers";
import { useIntersectionObserver } from "usehooks-ts";

export const useMediaLazyLoad = () => {
  const { view } = useViewContext();
  const shouldSkip = view === "pdf";

  const { isIntersecting, ref: setObserverRef } = useIntersectionObserver({
    rootMargin: "250px 0px",
    freezeOnceVisible: true,
    initialIsIntersecting: shouldSkip,
  });

  return { isVisible: shouldSkip || isIntersecting, setObserverRef };
};
